<template>
  <div>
    <div class="mt-15 container card_container">
      <div class="mb-5 titolo">
        <h3 class="text-white mt-5 text-center"><i class="fas fa-clipboard-list"></i> Lista appuntamenti</h3>
      </div>
      <b-container class="bv-example-row">
        <b-card bg-variant="light">
          <b-container class="bv-example-row pt-lg-6">
            <b-row>
              <b-col sm class="mb-7">
                <span class="text-primary">Codice fiscale</span><br/>
                <span>{{ jsonData.assistito.codiceFiscale }}</span>
              </b-col>
              <b-col sm class="mb-7">
                <span class="text-primary">Assistito</span><br/>
                <span>{{ jsonData.assistito.nome }} {{ jsonData.assistito.cognome }}</span>
              </b-col>
              <b-col sm class="mb-7">
                <span class="text-primary">Data di nascita</span><br/>
                <span>{{ jsonData.assistito.dataNascita }}</span>
              </b-col>
            </b-row>
          </b-container>
        </b-card>
      </b-container>
    </div>
    <div v-if="jsonData.prenotazioni != null && jsonData.prenotazioni.length > 0">
      <div v-for="item in jsonData.prenotazioni" :key="item.idTransazione">
        <div class="mt-5 container card_container mb-5" v-if="jsonData.assistito.codiceFiscale">
          <b-card bg-variant="light" class="mb-5">
            <b-container class="bv-example-row pt-lg-6">
              <b-row>
                <b-col sm class="mb-7">
                  <span class="text-primary">Struttura</span><br/>
                  <span>ASREM</span>
                </b-col>
                <b-col sm class="mb-7">
                  <span class="text-primary">Emissione Ricetta</span><br/>
                  <span>{{ item.dataEmissioneRicetta }}</span>
                </b-col>
                <b-col sm class="mb-7">
                  <!-- <span v-if="item.nre.match(/^\d{4}A\d{10}$/g) != null" class="text-primary">Codice impegnativa</span> -->
                  <span v-if="item.nre != null && item.nre.match(/^\d{4}A\d{10}$/g)" class="text-primary">Codice impegnativa</span>
                  <span v-else class="text-primary">Tipo Erogazione</span>
                  <br/>

                  <span v-if="item.nre != null">{{ item.nre }}</span>
                  <span v-else> Prestazione Privata</span>
                </b-col>
              </b-row>
            </b-container>
          </b-card>
          <div>
            <b-button class="mx-2 mb-2 btn btn-primary" @click="onScarica(item)" v-b-modal.pdfmodel><i
                class="fas fa-file-download fs-2x"></i> Promemoria Prenotazione
            </b-button>
            <b-button
                class="mx-2 mb-2 btn btn-primary"
                :disabled="!item.abilitaAnnullamento"
                :title="!item.abilitaAnnullamento ? item.messaggioAnnullamento : ''"
                @click="onCancella(item)"
            ><i class="fas fa-trash-alt fs-2x"></i> Disdetta
            </b-button>
            <!--<router-link :to="{ path: '/listapendenze' }">
              <b-button class="mx-2 mb-2 btn-primary">
                Vai al pagamento
              </b-button>
            </router-link>-->
          </div>
          <div class="my-5">
            <datatable-lista-appuntamenti :appuntamenti="item.appuntamenti"
                                          :idModal="item.idPrenotazione"></datatable-lista-appuntamenti>
          </div>
          <b-card bg-variant="light" class="border-footer-card">
            <b-container class="bv-example-row">
              <b-row class="pt-lg-6">
                <b-col sm class="mb-7">
                  <span class="text-primary">Priorità:</span><span style="margin-left: 10px">{{
                    item.classePriorita
                  }}</span>
                </b-col>
                <b-col sm class="mb-7">
                  <span class="text-primary">Tipo esenzione:</span>
                  <span style="margin-left: 10px">N/D</span>
                </b-col>
                <b-col sm class="mb-7">
                  <span class="text-primary">Importo:</span>
                  <span style="margin-left: 10px">{{ item.importo }} €</span>
                </b-col>
              </b-row>
            </b-container>
          </b-card>
        </div>
      </div>
    </div>
    <div v-else-if="jsonData.prenotazioni != null && jsonData.prenotazioni.length === 0">
      <div class="mt-5 container card_container mb-5">
        <b-card bg-variant="light" class="mb-5">
          <b-container class="bv-example-row pt-lg-6">
            <b-row class="text-center">
              <b-col sm class="mb-7">
                <strong><span style="margin-left: 10px" class="text-center">Non ci sono appuntamenti</span></strong>
              </b-col>
            </b-row>
          </b-container>
        </b-card>
      </div>
    </div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" color="#274561" loader="dots"
             :height="120" :width="120"></loading>
    <pdf-viewer :pdf="jsonData.pdf" :title="title"></pdf-viewer>
  </div>
</template>
<script>
import datatableListaAppuntamenti from "../datatable/datatableListaAppuntamenti.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import pdfViewer from "../pdfViewer/pdfViewer.vue";
import strutture from "../../classes/strutture";
import UtilityMixin from "../../utilities/utilityMixin";
import AuthService from "@/services/authService";
import EngiService from "@/services/engiService";
import getVocabolario from "@/utilities/utilityCercaVocabolario";

export default {
  mixins: [UtilityMixin],
  components: {
    datatableListaAppuntamenti,
    Loading,
    pdfViewer,
  },
  data() {
    return {
      messaggioPreAnnullamento: JSON.parse(sessionStorage.getItem("messaggiUtente")).preAnnullamento,
      pathResourceAppuntamenti: "/api/v2.0/appecupt/aslengi/listaappuntamenti",
      pathResourceContatti: "/api/v2.0/appecupt/auth/me",
      pathResourceInfoUtente: "/api/v2.0/appecupt/auth/prelevaAnagraficaUtente",
      pathResourceScarica: "/api/v2.0/appecupt/aslengi/stampaInvioRicevuta",
      pathResourceAnnulla: "/api/v2.0/appecupt/aslengi/annullaImpegnativa",
      contattiOptions: [{value: null, contatto: "Seleziona Assistito", disabled: true}],
      jsonData: {
        assistito: {},
        prenotazioni: null,
        pdf: null,
      },
      token: null,
      tokenLogin: null,
      isLoading: false,
      listaStrutture: strutture,
      title: "Promemoria Prenotazione",
    };
  },
  mounted: function () {
    let me = this;
    me.token = sessionStorage.getItem("tokenWSO2");
    me.tokenLogin = sessionStorage.getItem("loginData");
    me.loadInfoUtente();
  },
  watch: {
    "jsonData.assistito.codiceFiscale": function () {
      let me = this;
      if (me.jsonData.assistito.codiceFiscale) {
        me.loadAppuntamenti();
      }
    },
  },
  methods: {
    async loadInfoUtente() {
      let me = this;
      try {
        const responseInfoUtente = await AuthService.anagraficaUtente(me.tokenLogin);
        me.jsonData.assistito = responseInfoUtente.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async loadAppuntamenti() {
      let me = this;
      me.isLoading = true;
      try {
        const responseAppuntamenti = await EngiService.listaAppuntamenti(me.jsonData.assistito.codiceFiscale);
        me.jsonData.prenotazioni = responseAppuntamenti.data.data;
        me.isLoading = false;
      } catch (e) {
        me.isLoading = false;
        me.$bvModal
            .msgBoxOk(e, {
              title: "Errore",
              size: "md",
              okVariant: "outline-danger",
              headerClass: "vv-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then(() => {
              me.isLoading = false;
            })
            .catch(() => {
              me.isLoading = false;
            });
      }
    },
    async onScarica(item) {
      let me = this;
      me.isLoading = true;
      try {
        const paramentriRicevutaPrenotazione = {
          codiceFiscale: me.jsonData.assistito.codiceFiscale,
          idTransazione: item.idTransazione,
        };
        const responseRicevutaPrenotazione = await EngiService.stampaRicevutaPrenotazione(paramentriRicevutaPrenotazione);
        me.jsonData.pdf = responseRicevutaPrenotazione.data.data;
        me.isLoading = false;
      } catch (e) {
        me.isLoading = false;
        me.$bvModal
            .msgBoxOk(e, {
              title: "Errore",
              size: "md",
              okVariant: "outline-danger",
              headerClass: "vv-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then(() => {
              me.isLoading = false;
            })
            .catch(() => {
              me.isLoading = false;
            });
      }
    },
    onCancella(item) {
      let me = this;
      let appuntamenti = [];

        let msg = getVocabolario("annullamentoPrenotazioneDomanda")
        if(!msg)
            msg = "Sei sicuro di voler Disdire la prenotazione?"
      this.$bvModal
          .msgBoxConfirm(msg, {
            title: "Conferma Disdetta",
            footerClass: "p-2",
            centered: true,
            cancelTitle: "Chiudi",
            okTitle: "Conferma",
          })
          .then(async (response) => {
            if (response) {
              item.appuntamenti.forEach((appuntamento) => {
                appuntamenti.push({
                  codAppuntamento: appuntamento.codAppuntamento,
                  desPrestazione: appuntamento.desPrestazione,
                  dataAppuntamento: `${appuntamento.dataAppuntamento} ${appuntamento.oraAppuntamento}`,
                });
              });
              me.isLoading = true;
              try {
                const paramentriAnnullaImpegnativa = {
                  nre: item.nre,
                  assistito: me.jsonData.assistito,
                  appuntamenti: appuntamenti,
                };
                const responseAnnullaPrenotazione = await EngiService.annullaPrenotazione(paramentriAnnullaImpegnativa);
                me.isLoading = false;
                if (responseAnnullaPrenotazione.data.stato === 200) {
                  me.$bvModal
                      .msgBoxOk(responseAnnullaPrenotazione.data.data, {
                        title: "Esito Disdetta",
                        size: "md",
                        okVariant: "primary",
                        headerClass: "header-success",
                        footerClass: "p-2 border-top-0",
                        centered: true,
                      })
                      .then(() => {
                        me.loadAppuntamenti();
                      })
                      .catch(() => {
                      });
                } else {
                  me.$bvModal
                      .msgBoxOk(response.data.errore, {
                        title: "Errore Annullamento",
                        size: "md",
                        okVariant: "outline-danger",
                        headerClass: "vv-msg-header-danger",
                        footerClass: "p-2 border-top-0",
                        centered: true,
                      })
                      .then(() => {
                        me.loadAppuntamenti();
                      })
                      .catch(() => {
                      });
                }
              } catch (error) {
                me.isLoading = false;
                me.$bvModal
                    .msgBoxOk(error, {
                      title: "Errore",
                      size: "md",
                      okVariant: "outline-danger",
                      headerClass: "vv-msg-header-danger",
                      footerClass: "p-2 border-top-0",
                      centered: true,
                    })
                    .then(() => {
                      me.isLoading = false;
                    })
                    .catch(() => {
                      me.isLoading = false;
                    });
              }
            }
          })
          .catch((error) => {
            me.isLoading = false;
            me.$bvModal
                .msgBoxOk(error, {
                  title: "Errore",
                  size: "md",
                  okVariant: "outline-danger",
                  headerClass: "vv-msg-header-danger",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                })
                .then(() => {
                  me.isLoading = false;
                })
                .catch(() => {
                  me.isLoading = false;
                });
            me.loadData();
          });
    },
  },
};
</script>
